import Vue from 'vue';
import Draggable from 'vuedraggable';
import VueFormulate from '@braid/vue-formulate';
import VueCompositionApi from '@vue/composition-api';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import App from './App.vue';
import { router } from './router/router';
import { store } from './store/store';
import { api } from './api/api';
import { LS_TOKEN } from './api/token';
import { formulateSetup } from './formulateSetup';
import './assets/tailwind.css';
import './assets/formulate.css';
import './assets/virtual-scroller.css';
import './registerBaseComponents';
import './registerIcons';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://a12e47690b2d47e1ac03aba0cd7bc77d@o57426.ingest.sentry.io/5315712',
    integrations: [
      new VueIntegration({ Vue, attachProps: true, logErrors: true }),
    ],
  });
}

Vue.component('draggable', Draggable);
Vue.use(VueFormulate, formulateSetup);
Vue.use(VueCompositionApi);
Vue.use(VueVirtualScroller);
Vue.config.productionTip = false;
Vue.prototype.$api = api;

const existingToken = window.localStorage.getItem(LS_TOKEN);
if (existingToken) {
  store.dispatch('auth/login', existingToken);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
